import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_item = _resolveComponent("grid-item")
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide = _resolveComponent("splide")

  return (_openBlock(), _createBlock(_component_splide, {
    class: "-mr-16 tablet:-mr-52",
    options: {
      type: 'slide',
      arrows: false,
      pagination: false,
      fixedWidth: $props.columnCountDesktop === 4 ? '22.5%' : '17.5%',
      flickMaxPages: 1,
      flickPower: 100,
      perMove: 1,
      gap: '2rem',
      mediaQuery: 'max',
      breakpoints: {
        768: {
          fixedWidth: $props.columnCountMobile === 1 ? '88%' : '63%',
          gap: '1rem',
        },
      },
    }
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.products, (product) => {
        return (_openBlock(), _createBlock(_component_splide_slide, {
          key: product.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_grid_item, {
              product: product,
              "lazyload-media": true
            }, null, 8, ["product"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["options"]))
}